export enum ContributorTypeEnum {
  CONTRIBUTOR = 'CONTRIBUINTE',
  NO_CONTRIBUTOR = 'NÃO CONTRIBUINTE'
}

export enum ContributorTypeIdEnum {
  'CONTRIBUINTE' = 1,
  'NÃO CONTRIBUINTE' = 2,
}

export function getContributorTypeDescriptionByValue(value: number) {
  const indexOfS = Object.values(ContributorTypeIdEnum).indexOf(
    value as unknown as ContributorTypeIdEnum
  );

  const key = Object.keys(ContributorTypeIdEnum)[indexOfS];

  return key;
}


